<template>
  <div class="w-64 bg-blue-900 text-white flex flex-col">
    <div class="p-4 pb-6 flex items-center">
      <router-link to="/" class="text-2xl font-bold text-white">ALLDOQ</router-link>
    </div>

    <nav class="flex-1">
      <ul class="space-y-2">
        <li>
          <router-link to="/dashboard" class="flex items-center py-3 px-4 w-full text-white hover:bg-blue-800">
            <i class="fas fa-gauge mr-3"></i>
            <span>Dashboard</span>
          </router-link>
        </li>
        <li>
          <router-link to="/customers" class="flex items-center py-3 px-4 w-full text-white hover:bg-blue-800">
            <i class="fas fa-users-gear mr-3"></i>
            <span>Customers</span>
          </router-link>
        </li>
        <li>
          <router-link to="/users" class="flex items-center py-3 px-4 w-full text-white hover:bg-blue-800">
            <i class="fas fa-users mr-3"></i>
            <span>Users list</span>
          </router-link>
        </li>
        <li v-if="authStore.canManageOrganisations" class="pt-4 mt-4 border-t border-blue-800">
          <router-link to="/organisations" class="flex items-center py-3 px-4 w-full text-white hover:bg-blue-800">
            <i class="fas fa-building mr-3"></i>
            <span>ALLDOQ Core</span>
          </router-link>
        </li>
        <li v-if="authStore.canManageOrganisations" class="px-4 pb-2">
          <label for="exchange-instance" class="block text-xs text-blue-300 mb-1">Exchange instance</label>
          <select
            id="exchange-instance"
            class="w-full bg-blue-800 text-white text-sm border border-blue-700 rounded px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-blue-500"
            :value="authStore.exchangeInstance"
            @change="onInstanceChange"
          >
            <option value="core">Core (all customers)</option>
            <option value="tula">Tula (larger customer)</option>
          </select>
        </li>
        <li v-if="authStore.canManageOrganisations">
          <router-link to="/associates" class="flex items-center py-3 px-4 w-full text-white hover:bg-blue-800">
            <i class="fas fa-user-tie mr-3"></i>
            <span>Associates</span>
          </router-link>
        </li>
        <li v-if="authStore.canManageOrganisations">
          <router-link to="/feature-flags" class="flex items-center py-3 px-4 w-full text-white hover:bg-blue-800">
            <i class="fas fa-toggle-on mr-3"></i>
            <span>Feature flags</span>
          </router-link>
        </li>
        <li v-if="authStore.canManageOrganisations">
          <router-link to="/manuals" class="flex items-center py-3 px-4 w-full text-white hover:bg-blue-800">
            <i class="fas fa-book mr-3"></i>
            <span>Manuals</span>
          </router-link>
        </li>
        <li v-if="authStore.canManageOrganisations">
          <router-link to="/manuals/review" class="flex items-center py-3 px-4 w-full text-white hover:bg-blue-800">
            <i class="fas fa-clipboard-check mr-3"></i>
            <span>Manual review</span>
            <span v-if="pendingReviews"
                  class="ml-auto text-xs px-1.5 py-0.5 rounded-full bg-amber-400 text-amber-900 font-medium">
              {{ pendingReviews }}
            </span>
          </router-link>
        </li>
        <li v-if="authStore.canManageOrganisations">
          <router-link to="/policies" class="flex items-center py-3 px-4 w-full text-white hover:bg-blue-800">
            <i class="fas fa-file-contract mr-3"></i>
            <span>Policies &amp; docs</span>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue'
import { useAuthStore } from '../store/auth'
import { useManualsStore } from '../store/manuals'

const authStore = useAuthStore()
const manualsStore = useManualsStore()

// A review queue nobody is reminded about is a review queue that fills up. The
// count comes from the sets, which are cheap to load and already carry it.
const pendingReviews = computed(() =>
  manualsStore.sets.reduce((total, set) => total + (set.pending_suggestions || 0), 0)
)

const loadCounts = () => {
  if (authStore.canManageOrganisations && !manualsStore.sets.length) manualsStore.fetchSets()
}

onMounted(loadCounts)
watch(() => authStore.canManageOrganisations, loadCounts)

// Switch which exchange (alldoq core) deployment the console manages. The
// selected instance is persisted and sent as X-Exchange-Instance on every
// proxy request to the exchange.
const onInstanceChange = (event) => {
  authStore.setExchangeInstance(event.target.value)
}
</script> 